export const hasSubscriptionAccess = status => ['active', 'trialing'].includes(status);
